import React from 'react';
import Layout from '../../../components/Layout';
import ProductTransactions from './index';

const ProductTransactionsPage = () => {
    return (
        <Layout>
            <ProductTransactions />
        </Layout>
    );
};

export default ProductTransactionsPage;
